import IPaginator from "./Paginator";
import * as Yup from "yup";
import PaginatorComp from "../components/common/PaginatorComp";


export enum IActivityType{
    MeetingInvited = "MEETING_INVITED",
    MeetingAttended = "MEETING_ATTENDED",
    ContentVisited = "CONTENT_VISITED",
    ContentShared = "CONTENT_SHARED",
    None = "None",
    All = "ALL"
}

export const ACTIVITY_FILTER_SCHEMA = Yup.object({
    timeline: Yup.string().default('TODAY'),
    activityTypes: Yup.array().of(Yup.string()).default([IActivityType.All]).defined(),
    customerId: Yup.string(),
    contentId: Yup.string()
}).defined();

export type IActivityFilter = Yup.InferType<typeof ACTIVITY_FILTER_SCHEMA>;

export const MEETING_SCHEMA = Yup.object({
  uid: Yup.string().default('').defined(),
  title: Yup.string().default('').defined(),
  invitedOn: Yup.number().defined(),
  duration: Yup.number().default(0).defined(),
}).defined()

export type IActivityMeeting = Yup.InferType<typeof MEETING_SCHEMA>;

export const ACTOR_SCHEMA = Yup.object({
  uid: Yup.string().default('').defined(),
  name: Yup.string().default('').defined(),
  imageUrl: Yup.string().default('').defined(),
  role: Yup.string().default('').defined()
}).defined();

export type IActivityActor = Yup.InferType<typeof ACTOR_SCHEMA>;

export const CONTENT_SCHEMA = Yup.object({
  uid: Yup.string().default('').defined(),
  title: Yup.string().default('').defined(),
  duration: Yup.number().default(0).defined()
}).defined();

export type IActivityContent = Yup.InferType<typeof CONTENT_SCHEMA>;

export const ACTIVITY_SCHEMA = Yup.object({
    uid: Yup.string(),
    activityType: Yup.string().defined().default(IActivityType.None),
    content: CONTENT_SCHEMA,
    meeting: MEETING_SCHEMA,
    primaryActor: ACTOR_SCHEMA,
    secondaryActors: Yup.array().of(ACTOR_SCHEMA).defined(),
    channel: Yup.string().defined().default('WEB'),
    time: Yup.number().defined(),
    customProperties: Yup.array().of(Yup.object({
        name: Yup.string().default(''),
        value: Yup.string().default('')
    }))
}).defined();

type IActivity = Yup.InferType<typeof ACTIVITY_SCHEMA>;

export const newActivityFilterInstance = ():IActivityFilter => {
    return ACTIVITY_FILTER_SCHEMA.cast()
}

export const newActivityInstance = ():IActivity => {
  const obj =  ACTIVITY_SCHEMA.cast();
  return Object.assign({},obj);
}


export const isActivityValid = async (doc:IActivity) => {
  const valid:boolean =  await ACTIVITY_SCHEMA.isValid(doc);
  return valid;
}

export const convertToActivity = (doc:any):IActivity => {
  return ACTIVITY_SCHEMA.cast(doc);
}

export interface IActivityCollection {
    activities: Array<IActivity>,
    paginator: IPaginator
}

export default IActivity;